"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const abstract_block_component_1 = require("../abstract-block/abstract-block.component");
let BuildingBlockColumnComponent = 
// eslint-disable-next-line max-len
class BuildingBlockColumnComponent extends abstract_block_component_1.AbstractBuildingBlock {
    constructor() {
        super(...arguments);
        this.edit = new core_1.EventEmitter();
        this.editBlock = (event) => {
            this.edit.emit(event);
        };
        this.deleteBlock = (index) => {
            this.block.blocks.splice(index, 1);
        };
        this.moveBlock = (index, direction) => {
            const { blocks } = this.block;
            const toIndex = index + direction;
            if (index < 0 || index >= blocks.length || toIndex < 0 || toIndex >= blocks.length)
                return;
            const [movedElement] = blocks.splice(index, 1);
            blocks.splice(toIndex, 0, movedElement);
        };
    }
};
__decorate([
    (0, core_1.Output)(),
    __metadata("design:type", Object)
], BuildingBlockColumnComponent.prototype, "edit", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], BuildingBlockColumnComponent.prototype, "activeEditComponent", void 0);
BuildingBlockColumnComponent = __decorate([
    (0, core_1.Component)({
        selector: 'block-column',
        templateUrl: require('./column-block.component.html'),
    })
    // eslint-disable-next-line max-len
], BuildingBlockColumnComponent);
exports.default = BuildingBlockColumnComponent;
